import { NICmsContentField } from '@icms/core/content';
import { NBuilderConfig } from '../../common/builder.config';
export namespace NOutfitGeneralSetup {
    export enum EGender {
        men = 5887,
        women = 5888
    }
    export enum EHorseType {
        horse = 7814,
        pony = 7815
    }
    export interface IGeneralSetupData {
        horseShift: number;
        riderShift: number;

        firstStepTitle: string;
        firstStepOptions: NBuilderConfig.ISetupElementData[];
        riderStepTitle: string;
        riderStepWomenOptions: NBuilderConfig.ISetupElementData[];
        riderStepMenOptions: NBuilderConfig.ISetupElementData[];
        horseStepTitle: string;
        horseStepHorseOptions: NBuilderConfig.ISetupElementData[];
        horseStepPonyOptions: NBuilderConfig.ISetupElementData[];
        riderAndHorseZoom?: number;
        riderTopShift?: number;
        riderLeftShift?: number;
        riderZoom?: number;
        horseTopShift?: number;
        horseLeftShift?: number;
        horseZoom?: number;
    }
    export const setupElementFields = [
        <NICmsContentField.IField>{
            key: 'name',
            type: NICmsContentField.EFieldType.text,
            title: 'Name',
            description: 'Name of option have to be uniq cause it is use as identifier of option',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'image',
            title: 'Image',
            type: NICmsContentField.EFieldType.image,
            required: true,
            default: '/cms/media/default.png'
        },
        <NICmsContentField.IField>{
            key: 'preselect',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Preselect',
            default: false
        },
        <NICmsContentField.IField>{
            key: 'imageConfiguration',
            title: 'Image product configuration',
            type: NICmsContentField.EFieldType.image,
            required: true,
            default: '/cms/media/default.png'
        },
        <NICmsContentField.IField>{
            key: 'alternativeImageConfiguration',
            title: 'Alternative image',
            type: NICmsContentField.EFieldType.image,
            description: 'This image will be displayed instead image configuration when product form specific section is selected',
            default: '/cms/media/default.png'
        }
    ];
    export const generalSetupFields = [
        {
            type: NICmsContentField.EFieldType.label,
            tab: 'Builder General Setup',
            key: 'typeData.configuration-step',
            title: 'Configure step'
        },
        <NICmsContentField.IField>{
            tab: 'Builder General Setup',
            key: 'typeData.firstStepTitle',
            type: NICmsContentField.EFieldType.text,
            title: 'First step title',
            default: 'Configure your outfit for',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            tab: 'Builder General Setup',
            key: 'typeData.firstStepOptions',
            type: NICmsContentField.EFieldType.repeater,
            title: 'First step options',
            description:
                'Order of options is important (rider & horse, rider, horse)  cause it is used to generate corect steps in builder. If step should be selected by default set preselect to true',
            itemName: 'Option',
            itemNameField: 'name',
            required: true,
            defaultSize: 3,
            minSize: 3,
            maxSize: 3,
            fields: [
                <NICmsContentField.IField>{
                    key: 'name',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Name',
                    description: 'Name of option have to be uniq cause it is use as identifier of option',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'image',
                    title: 'Image',
                    type: NICmsContentField.EFieldType.image,
                    required: true,
                    default: '/cms/media/default.png'
                },
                <NICmsContentField.IField>{
                    key: 'mobileImage',
                    title: 'Mobile image',
                    type: NICmsContentField.EFieldType.image,
                    default: '/cms/media/default.png',
                    required: false
                },
                <NICmsContentField.IField>{
                    key: 'preselect',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Preselect',
                    default: false
                }
            ],
            default: [
                {
                    name: 'Rider & Horse',
                    image: '/cms/media/default.png',
                    preselect: true
                },
                {
                    name: 'Rider',
                    image: '/cms/media/default.png'
                },
                {
                    name: 'Horse',
                    image: '/cms/media/default.png'
                }
            ]
        },
        {
            type: NICmsContentField.EFieldType.label,
            tab: 'Builder Rider Setup',
            key: 'typeData.rider-step',
            title: 'Options'
        },
        <NICmsContentField.IField>{
            tab: 'Builder Rider Setup',
            key: 'typeData.riderStepTitle',
            type: NICmsContentField.EFieldType.text,
            title: 'Rider step title',
            default: 'Select your rider',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            tab: 'Builder Rider Setup',
            key: 'typeData.riderStepWomenOptions',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Rider women options',
            itemName: 'Option',
            itemNameField: 'name',
            required: true,
            defaultSize: 4,
            fields: setupElementFields
        },
        <NICmsContentField.IRepeaterField>{
            tab: 'Builder Rider Setup',
            key: 'typeData.riderStepMenOptions',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Rider men options',
            itemName: 'Option',
            itemNameField: 'name',
            defaultSize: 4,
            fields: setupElementFields
        },
        {
            type: NICmsContentField.EFieldType.label,
            tab: 'Builder Horse Setup',
            key: 'typeData.horse-step',
            title: 'Options'
        },
        <NICmsContentField.IField>{
            tab: 'Builder Horse Setup',
            key: 'typeData.horseStepTitle',
            type: NICmsContentField.EFieldType.text,
            title: 'Horse step title',
            default: 'Select your horse',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            tab: 'Builder Horse Setup',
            key: 'typeData.horseStepHorseOptions',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Horse options',
            itemName: 'Option',
            itemNameField: 'name',
            required: true,
            defaultSize: 4,
            fields: setupElementFields
        },
        <NICmsContentField.IRepeaterField>{
            tab: 'Builder Horse Setup',
            key: 'typeData.horseStepPonyOptions',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Pony options',
            itemName: 'Option',
            itemNameField: 'name',
            defaultSize: 4,
            fields: setupElementFields
        },
        {
            type: NICmsContentField.EFieldType.label,
            tab: 'Builder General Setup',
            key: 'typeData.product-step',
            title: 'Images positions for combination of rider and horse'
        },
        <NICmsContentField.INumberField>{
            tab: 'Builder General Setup',
            key: 'typeData.horseShift',
            type: NICmsContentField.EFieldType.number,
            title: 'Horse image position',
            required: true,
            min: -40,
            max: 40,
            default: 8
        },
        <NICmsContentField.INumberField>{
            tab: 'Builder General Setup',
            key: 'typeData.riderShift',
            type: NICmsContentField.EFieldType.number,
            title: 'Rider image position',
            required: true,
            min: -40,
            max: 40,
            default: -38
        },
        <NICmsContentField.INumberField>{
            tab: 'Builder General Setup',
            key: 'typeData.riderAndHorseZoom',
            type: NICmsContentField.EFieldType.number,
            title: 'Rider and horse default zoom',
            default: 2,
            min: 1,
            max: 3
        },
        {
            type: NICmsContentField.EFieldType.label,
            tab: 'Builder General Setup',
            key: 'typeData.product-step-rider',
            title: 'Images zoom and positions for rider'
        },
        <NICmsContentField.INumberField>{
            tab: 'Builder General Setup',
            key: 'typeData.riderTopShift',
            type: NICmsContentField.EFieldType.number,
            title: 'Rider image top position',
            min: -40,
            max: 40,
            default: 0
        },
        <NICmsContentField.INumberField>{
            tab: 'Builder General Setup',
            key: 'typeData.riderLeftShift',
            type: NICmsContentField.EFieldType.number,
            title: 'Rider image left position',
            min: -40,
            max: 40,
            default: 0
        },
        <NICmsContentField.INumberField>{
            tab: 'Builder General Setup',
            key: 'typeData.riderZoom',
            type: NICmsContentField.EFieldType.number,
            title: 'Rider default zoom',
            default: 2,
            min: 1,
            max: 3
        },
        {
            type: NICmsContentField.EFieldType.label,
            tab: 'Builder General Setup',
            key: 'typeData.product-step-horse',
            title: 'Images zoom and positions for horse'
        },
        <NICmsContentField.INumberField>{
            tab: 'Builder General Setup',
            key: 'typeData.horseTopShift',
            type: NICmsContentField.EFieldType.number,
            title: 'Horse image top position',
            min: -40,
            max: 40,
            default: 0
        },
        <NICmsContentField.INumberField>{
            tab: 'Builder General Setup',
            key: 'typeData.horseLeftShift',
            type: NICmsContentField.EFieldType.number,
            title: 'Horse image left position',
            min: -40,
            max: 40,
            default: 0
        },
        <NICmsContentField.INumberField>{
            tab: 'Builder General Setup',
            key: 'typeData.horseZoom',
            type: NICmsContentField.EFieldType.number,
            title: 'Horse default zoom',
            default: 2,
            min: 1,
            max: 3
        }
    ];
}
